import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';
import { mapActions, mapGetters } from 'vuex';
import contentLoaderMixin from '@/mixins/contentLoader';

export default {
  mixins: [contentLoaderMixin],
  components: {
    swiper: Swiper,
    swiperSlide: SwiperSlide,
  },
  data() {
    return {
      items: [],
      swiperModules: [Autoplay, Pagination],
      swiperOptions: {
        loop: false,
        autoplay: { enabled: true, delay: 5000 },
        direction: 'horizontal',
        pagination: { el: '.hero-unit-slider__pagination', clickable: true },
      },
    };
  },
  computed: {
    ...mapGetters('app', ['isShutdownModeOn']),
    classModifiers() {
      return {
        'hero-unit-slider': true,
        'hero-unit-slider--shutdown': this.isShutdownModeOn,
      };
    },
  },
  methods: {
    ...mapActions('browse', ['getCarousel']),
    getBannerUrl(banner) {
      if (banner.carouselData.carouselItemButton.url) {
        return banner.carouselData.carouselItemButton.url;
      } else if (banner.carouselData.marketId) {
        return { name: 'market-details', params: { marketId: banner.carouselData.marketId } };
      }
      return {};
    },
    isUrlExternal(banner) {
      const url = banner.carouselData.carouselItemButton.url || '';
      return url.startsWith('http');
    },
    bannerImageStyleModifiers(url) {
      if (!url) return {};
      return {
        'background-image': `url('${url}')`,
      };
    },
    buttonStyleModifiers(button) {
      const styles = {};
      if (button.backgroundColor) {
        styles.backgroundColor = button.backgroundColor;
        styles.borderColor = button.backgroundColor;
      }
      return styles;
    },
  },
  created() {
    this.getCarousel().then((data) => {
      this.items = data;
      this.isComponentReady = this.items.length > 0;
    });
  },
};
